module.exports = __webpack_public_path__ + "static/media/400412_01.2fff297e.png";